import { User } from '@/classes/auth';
export default class OptimizelyService {
  public static readonly HIDE_INVOICE_PAYMENT_TEST_ID = 'CNV-4102';
  /**
   * USE THIS FOR OPTIMIZELY WEB EXPERIMENTS ONLY
   *
   * @param eventName
   * @param tags
   */
  public static trackEvent(eventName: string, tags: object | null = null): void {
    window['optimizely'] = window['optimizely'] || [];

    // Sends a tracking call to Optimizely for the given event name
    const data = {
      type: 'event',
      eventName: eventName,
    };

    if (tags) {
      Object.assign(data, { tags });
    }
    // @ts-ignore
    window['optimizely'].push(data);
  }

  /**
   * USE THIS FOR OPTIMIZELY WEB EXPERIMENTS ONLY
   *
   * @param experimentId
   * @param variantId
   */
  public static isAbTestVariantActive(experimentId: string | null = null, variantId: string | null = null): boolean {
    if (experimentId === null || variantId === null) return false;
    if (this.optimizelyIsNotInitialized()) return false; // If Optimizely is not active/available

    const optimizelyState = window.optimizely.get('state');
    return (
      optimizelyState.getActiveExperimentIds().includes(experimentId) &&
      optimizelyState.getVariationMap()[experimentId].id == variantId
    );
  }

  public static optimizelyIsNotInitialized(): boolean {
    return window.optimizely === undefined || window.optimizely === null;
  }

  public static isUserOnAbtestVariantCNV3020(): boolean {
    return OptimizelyService.isAbTestVariantActive('26353010905', '26442340272');
  }

  public static isUserOnAbtestVariantCNV3647(): boolean {
    return OptimizelyService.isAbTestVariantActive('6509345068810240', '5756073907322880');
  }

  /**
   * USE THIS FOR OPTIMIZELY FULLSTACK/FEATURE EXPERIMENTS ONLY
   *
   * Checks if a user is in a specific A/B test (any variant, not original)
   * @param user - The user object
   * @param testNumber - The test number (e.g., 'CNV-1234')
   * @returns true if user is in the test, false otherwise
   */
  public static isUserInAbTest(user: User, testNumber: string): boolean {
    if (user.team.ab_tests) {
      for (const test of user.team.ab_tests) {
        if (test.startsWith(testNumber)) {
          return !test.includes('original');
        }
      }
    }

    return false;
  }

  /**
   * USE THIS FOR OPTIMIZELY FULLSTACK/FEATURE EXPERIMENTS ONLY
   *
   * Gets the specific variant of an A/B test for a user
   * @param user - The user object
   * @param testNumber - The test number (e.g., 'CNV-1234')
   * @returns The variant string (e.g., 'original', 'variant1', 'variant2') or null if not in test
   */
  public static getAbTestVariant(user: User, testNumber: string): string | null {
    if (user.team.ab_tests) {
      for (const test of user.team.ab_tests) {
        if (test.startsWith(testNumber)) {
          // Extract variant from test string
          // Examples: 'CNV-1234-original' -> 'original',  'CNV-1234' -> 'variant1', 'CNV-1234-variant2' -> 'variant2'
          const variant = test.replace(testNumber, '').replace(/^-/, '');
          return variant || 'variant1';
        }
      }
    }

    return null;
  }
}
